import React from 'react';

import AgentTimeline from '~/components/AiChat/AgentTimeline/AgentTimeline';
import type { AgentTimelineEntry } from '~/components/AiChat/AgentTimeline/types';

import ProgressStatusLine from './ProgressStatusLine';
import type { ProgressStatus } from './types';

/**
 * A run's step-by-step checklist (FNOL inbox, document side panel). Rows come from the AI service's
 * plan, so this component owns only presentation.
 */
export const ProgressTimeline: React.FC<{
  entries: AgentTimelineEntry[];
  status?: ProgressStatus;
  pendingText?: string;
}> = ({ entries, status, pendingText }) => (
  <div className="flex flex-col gap-8">
    <ProgressStatusLine status={status} pendingText={pendingText} />
    <AgentTimeline entries={entries} isDefaultExpanded={false} />
  </div>
);

export default ProgressTimeline;
